// Enhanced overflow detection function that handles CSS text truncation
export const detectTruncatedText = (element: HTMLElement): boolean => {
  if (!element) return false;

  // Check for horizontal overflow
  const hasHorizontalOverflow = element.scrollWidth > element.clientWidth;

  // Check for CSS text truncation (ellipsis)
  const computedStyle = window.getComputedStyle(element);
  const hasTextTruncation =
    computedStyle.textOverflow === 'ellipsis' &&
    computedStyle.overflow === 'hidden' &&
    computedStyle.whiteSpace === 'nowrap';

  // If CSS truncation is applied, check if the text would overflow without it
  if (hasTextTruncation) {
    // Create a temporary element to measure the full text width
    const tempElement = element.cloneNode(true) as HTMLElement;
    tempElement.style.position = 'absolute';
    tempElement.style.visibility = 'hidden';
    tempElement.style.whiteSpace = 'nowrap';
    tempElement.style.overflow = 'visible';
    tempElement.style.textOverflow = 'unset';
    tempElement.style.maxWidth = 'none';
    tempElement.style.width = 'auto';

    document.body.appendChild(tempElement);
    const fullTextWidth = tempElement.scrollWidth;
    document.body.removeChild(tempElement);

    return fullTextWidth > element.clientWidth;
  }

  return hasHorizontalOverflow;
};
